import { GlobalStyles as MuiGlobalStyles } from '@mui/material';
import type { GlobalStylesProps as MuiGlobalStylesProps } from '@mui/material/GlobalStyles';

export type GlobalStylesProps = MuiGlobalStylesProps;

export const GlobalStyles = ({ ...rest }: GlobalStylesProps): JSX.Element => (
  <MuiGlobalStyles {...rest} />
);
